import React from "react";
import useOfflineStatus from "../../hooks/useOfflineStatus";

export default function OfflineBanner() {
  const isOffline = useOfflineStatus();

  if (!isOffline) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#fe3b00ff",
        color: "#ffffffff",
        textAlign: "center",
        padding: "10px",
        fontWeight: 600,
        zIndex: 9999,
        boxShadow: "0 -2px 5px rgba(0,0,0,0.2)",
      }}
      role="status"
      aria-live="polite"
    >
      You are offline — please go online to see upto date data.
    </div>
  );
}
